/* eslint-disable */

import * as clientService from "../services/httpsClient";

export const getCompanyBill = async (accessToken, params) => {
  try {
    return await clientService.getApi(`companybill`, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const getCompanyBillById = async (accessToken, id) => {
  try {
    const domain = `companybill/${id}`;
    return await clientService.getApi(domain, accessToken);
  } catch (error) {
    throw error;
  }
};

export const deleteCompanyBill = async (accessToken, body) => {
  try {
    const domain = `companybill`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const createCompanyBill = async (accessToken, body) => {
  try {
    const domain = `companybill/issue-bill`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const updateCompanyBill = async (accessToken, body) => {
  try {
    const domain = `companybill`;
    return await clientService.putApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getCompanyBillItem = async (accessToken, params) => {
  const { page, limit, company_bill_no } = params;
  let object = {};
  if (company_bill_no) {
    object.company_bill_no = company_bill_no;
  }
  if (page) {
    object.page = page;
  }
  if (limit) {
    object.limit = limit;
  }

  try {
    return await clientService.getApi(`companybill/items`, accessToken, object);
  } catch (error) {
    throw error;
  }
};

export const updateCompanyBillItem = async (accessToken, body) => {
  try {
    const domain = `companybill/items`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getCompanyBillImage = async (accessToken, params) => {
  const { company_bill_no } = params;
  try {
    return await clientService.getApi(`companybillimage/${company_bill_no}`, accessToken);
  } catch (error) {
    throw error;
  }
};

export const getCompanyBillImageList = async (accessToken, params) => {
  try {
    return await clientService.getApi(`companybillimage`, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const deleteCompanyBillImage = async (accessToken, body) => {
  try {
    return await clientService.deleteApi(`companybillimage`, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const createCompanyBillImage = async (accessToken, body) => {
  try {
    const domain = `companybillimage`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const getCompanyList = async (accessToken, params) => {
  try {
    return await clientService.getApi(`companybill/companylist`, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const getCompanyBillInvoice = async (accessToken, ids) => {
  try {
    const domain = `companybill/invoice`;
    return await clientService.postApi(domain, accessToken, { ids });
  } catch (error) {
    throw error;
  }
};

export const exportCompanyBill = async (accessToken, params) => {
  const { ids } = params;
  let body = {
    ids: ids,
  };
  try {
    const domain = `companybill/export-excel-bill`;
    return await clientService.exportExcelPost(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const exportCompanyBillAll = async (accessToken, searchParams) => {
  try {
    const domain = `companybill/export-excel-bill-all`;
    return await clientService.exportExcelPost(domain, accessToken, searchParams);
  } catch (error) {
    throw error;
  }
};

export const exportCompanyBillInvoice = async (accessToken, ids) => {
  try {
    const domain = `companybill/export-excel-invoice`;
    return await clientService.exportExcelPost(domain, accessToken, { ids });
  } catch (error) {
    throw error;
  }
};

export const exportCompanyBillInvoiceAll = async (accessToken, searchParams) => {
  try {
    const domain = `companybill/export-excel-invoice-all`;
    return await clientService.exportExcelPost(domain, accessToken, searchParams);
  } catch (error) {
    throw error;
  }
};

export const exportReportSummaryCompanyBill = async (accessToken, ids) => {
  try {
    const domain = `companybill/export-report-summary-bill`;
    return await clientService.exportExcelPost(domain, accessToken, { ids });
  } catch (error) {
    throw error;
  }
};

export const exportReportSummaryCompanyBillAll = async (accessToken, searchParams) => {
  try {
    const domain = `companybill/export-report-summary-bill-all`;
    return await clientService.exportExcelPost(domain, accessToken, searchParams);
  } catch (error) {
    throw error;
  }
};

export const updateCompanyBillStatus = async (accessToken, body) => {
  try {
    const domain = `companybill/update-bill-status`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};
